import { render, staticRenderFns } from "./carousel.html?vue&type=template&id=18bb7df2&scoped=true&external"
import script from "./carousel.js?vue&type=script&lang=js&external"
export * from "./carousel.js?vue&type=script&lang=js&external"
import style0 from "./carousel.scss?vue&type=style&index=0&id=18bb7df2&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18bb7df2",
  null
  
)

export default component.exports